/* src/app/modules/institutions/institutions-data/institutions-data-supplementary-numbers/institutions-data-supplementary-numbers.component.scss */
:host {
  width: 100%;
}
.cw-input {
  margin: 0;
}
.cw-input-label {
  margin-bottom: 5px;
}
.cw-input-label.multiple-lines {
  align-self: flex-start;
  display: flex;
}
.cw-button-wrapper {
  margin: 0;
  min-width: 30px;
  width: auto;
}
.cw-toolbar-icon {
  background-color: transparent;
  border: 1px solid transparent;
  color: var(--color-primary-dark);
  font-size: 12px;
  height: 25px;
  margin-left: 5px;
  width: 25px;
}
.cw-toolbar-icon:hover {
  border-color: var(--color-primary-dark);
}
.cw-toolbar-icon:active {
  background-color: var(--color-primary-dark);
  color: var(--color-default-light);
}
.row-header {
  align-self: flex-start;
  border-bottom: 1px solid var(--color-accent);
  font-weight: 700;
  margin-bottom: 5px;
  margin-top: 2px;
  padding-bottom: 10px;
  position: relative;
  align-items: center;
}
.row-header .cw-button-wrapper > .cw-toolbar-icon {
  position: absolute;
  right: 0;
  top: -5px;
}
.cw-supplementary-number {
  margin-right: 5px;
  max-width: 125px;
  width: 100%;
}
.cw-supplementary-number ::ng-deep input {
  min-width: 125px;
  width: 125px;
}
.cw-additional-note1 {
  margin-right: 5px;
  min-width: 150px;
  width: 150px;
}
.cw-additional-note2 {
  width: 100%;
}
.locked {
  margin-bottom: 2px;
  margin-right: 4px;
}
.locked-header {
  min-width: 60px;
}
.locked-icon {
  color: red;
}
:host .cw-editMode .cw-locked {
  align-items: center;
  display: flex;
  min-width: 60px;
  width: auto;
}
.input-container {
  align-items: center;
}
/*# sourceMappingURL=institutions-data-supplementary-numbers.component.css.map */
